import React from 'react'

import { Message } from 'sb-react-intl'

import s from './SidebarTitle.scss'


const SidebarTitle = ({ title }) => (
  <Message className={s.title} tag="div" text={title} />
)


export default SidebarTitle
